module.exports = flarum.core.compat['forum/states/GlobalSearchState'];